import '../styles/index.scss';

class Main {
    constructor() {
        this.onDOMLoaded();
        this.onDocumentLoad();
        this.onResize();
        this.onScroll();
        window.jQuery = window.$ = $;
    }

    onDocumentLoad() {
        window.addEventListener("load", (event) => {
        });
    }

    onDOMLoaded() {
        document.addEventListener("DOMContentLoaded", () => {
            // Aksamitna — scroll-triggered animations
            const animObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('ak-visible');
                    }
                });
            }, { threshold: 0.1, rootMargin: '-60px 0px' });

            document.querySelectorAll('.ak-animate, .ak-animate-left, .ak-animate-right, .ak-animate-scale')
                .forEach(el => animObserver.observe(el));

            // Aksamitna — header scroll state
            const akHeader = document.getElementById('ak-header');
            if (akHeader) {
                const onHeaderScroll = () => {
                    akHeader.classList.toggle('scrolled', window.scrollY > 50);
                };
                window.addEventListener('scroll', onHeaderScroll, { passive: true });
                onHeaderScroll();
            }

            // Aksamitna — floor plan tabs
            document.querySelectorAll('[data-ak-floor-btn]').forEach(btn => {
                btn.addEventListener('click', () => {
                    const target = btn.dataset.akFloorBtn;
                    const wrap   = btn.closest('[data-ak-floor-wrap]');
                    if (!wrap) return;
                    wrap.querySelectorAll('[data-ak-floor-btn]').forEach(b => b.classList.remove('active'));
                    wrap.querySelectorAll('.ak-floor-plan-pane').forEach(p => p.classList.remove('active'));
                    btn.classList.add('active');
                    const pane = wrap.querySelector('[data-ak-floor-pane="' + target + '"]');
                    if (pane) pane.classList.add('active');
                });
            });

            // Aksamitna — hotspot tooltips
            // Tooltip is a SIBLING of the button (inside the same wrapper div), not a child.
            document.addEventListener('click', e => {
                const btn = e.target.closest('[data-ak-hotspot]');
                if (btn) {
                    const tooltip = btn.parentElement.querySelector('.ak-hotspot-tooltip');
                    const isOpen  = tooltip && tooltip.classList.contains('open');
                    document.querySelectorAll('.ak-hotspot-tooltip.open')
                        .forEach(t => t.classList.remove('open'));
                    if (!isOpen && tooltip) tooltip.classList.add('open');
                    e.stopPropagation();
                    return;
                }
                const closeBtn = e.target.closest('[data-ak-tooltip-close]');
                if (closeBtn) {
                    closeBtn.closest('.ak-hotspot-tooltip')?.classList.remove('open');
                    e.stopPropagation();
                    return;
                }
                document.querySelectorAll('.ak-hotspot-tooltip.open')
                    .forEach(t => t.classList.remove('open'));
            });

            // Aksamitna — mobile menu
            const mobileMenuBtn = document.getElementById('ak-mobile-btn');
            const mobileMenu    = document.getElementById('ak-mobile-menu');
            if (mobileMenuBtn && mobileMenu) {
                mobileMenuBtn.addEventListener('click', () => {
                    const open = mobileMenu.classList.toggle('hidden') === false;
                    mobileMenuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
                });
            }
        });
    }


    onResize() {
        window.addEventListener('resize', (event) => {

        });
    }
    onScroll() {
        window.addEventListener('scroll', (event) => {

        });
    }

}

new Main();
